import { render, staticRenderFns } from "./remarks.vue?vue&type=template&id=40c4e7ed&scoped=true&"
import script from "./remarks.vue?vue&type=script&lang=js&"
export * from "./remarks.vue?vue&type=script&lang=js&"
import style0 from "./remarks.vue?vue&type=style&index=0&id=40c4e7ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c4e7ed",
  null
  
)

export default component.exports